module.exports = __webpack_public_path__ + "img/Seccion-5.b05534ed.png";